import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, switchMap, tap } from 'rxjs/operators';
import { NavigationService } from '@services/nav/nav.service';
import { BusinessUsersState } from '@state/business-users/business-users.state';

export const AdminOnlyGuard: CanActivateFn = () => {
	const navService = inject(NavigationService);
	const store = inject(Store);

	return store.select(BusinessUsersState.getLoaded).pipe(
		filter((loaded) => loaded), // wait for the state to be loaded
		switchMap(() => store.select(BusinessUsersState.isLoggedInUserAdmin)), // check if the user is an admin
		tap((isAdmin) => !isAdmin && navService.goToDashboard()), // redirect to the dashboard if the user is not an admin
	);
};
